module.exports = __webpack_public_path__ + "img/in_area.2f7a1d6.png";